import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../../basic-ui-components/icon/svg-icon/svg.icon';

export interface IBlogIconProps extends ISvgIconProps {

}

export class BlogIcon extends React.Component<IBlogIconProps> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <g fill="currentColor">
                    <path d="M21.577,21.477H2.596c-0.973-0.003-0.986-1.496,0-1.5c0,0,18.981,0,18.981,0C22.551,19.98,22.563,21.473,21.577,21.477z"/>
                    <path d="M7.425,17.696H2.596c-0.647,0.023-1.005-0.839-0.53-1.28c0.141-0.141,0.331-0.22,0.53-0.22h4.829
                        C8.404,16.2,8.407,17.692,7.425,17.696z"/>
                    <path d="M7.425,13.915H2.596c-0.647,0.022-1.005-0.838-0.53-1.28c0.141-0.141,0.331-0.22,0.53-0.22h4.829
                        C8.404,12.418,8.407,13.911,7.425,13.915z"/>
                    <path d="M21.577,17.696h-5c-0.199,0-0.39-0.079-0.53-0.22c-0.473-0.442-0.118-1.303,0.53-1.28c0,0,5,0,5,0
                        C22.555,16.2,22.558,17.692,21.577,17.696z"/>
                    <path d="M21.577,13.915h-2c-0.647,0.022-1.004-0.838-0.53-1.28c0.141-0.141,0.331-0.22,0.53-0.22h2
                        C22.556,12.419,22.557,13.911,21.577,13.915z"/>
                    <path d="M9.968,17.068c-0.188,0.052,0.623-3.725,0.61-3.832c0.017-0.093,0.051-0.182,0.101-0.262l5.508-8.834
                        c1.244-1.954,4.343-0.741,3.921,1.543c-0.05,0.278-0.154,0.543-0.307,0.78l-5.812,8.933c0.071,0.091-2.798,1.972-2.882,2.059
                        C10.715,17.741,10.104,17.535,9.968,17.068z M12.027,13.643l-0.283,1.547l1.069-0.738l5.732-8.814
                        c0.11-0.163,0.139-0.375,0.077-0.561c-0.145-0.514-0.899-0.609-1.166-0.147C17.456,4.929,12.027,13.643,12.027,13.643z"/>
                </g>
            </SvgIcon>
        );
    }
}
